exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".wrapper__1w1- {\n  align-items: center;\n  display: flex; }\n\n.icon__18Cr {\n  height: 16px;\n  margin-right: 5px; }\n  .icon__18Cr svg {\n    height: 100%; }\n", "", {"version":3,"sources":["/app/src/components/asset-library/src/components/asset-library/source-tab.scss"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,cAAc,EACf;;AAED;EACE,aAAa;EACb,kBAAkB,EAKnB;EAPD;IAKI,aAAa,EACd","file":"source-tab.scss","sourcesContent":[".wrapper {\n  align-items: center;\n  display: flex;\n}\n\n.icon {\n  height: 16px;\n  margin-right: 5px;\n\n  svg {\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"wrapper": "wrapper__1w1-",
	"icon": "icon__18Cr"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/asset-library/source-tab.scss
// module id = 885
// module chunks = 0